import { useSearchParams } from 'react-router-dom';
import { BlogList } from '@/components/BlogList';

export function BlogPage() {
  const [searchParams] = useSearchParams();
  const selectedCategory = searchParams.get('category');

  // Get category label for the title
  const getCategoryLabel = () => {
    switch(selectedCategory) {
      case 'ai':
        return 'AI Articles';
      case 'startups':
        return 'Startup Stories';
      case 'traveling':
        return 'Travel Adventures';
      case 'other':
        return 'Other Learnings';
      default:
        return 'Blog';
    }
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mb-8">
        <h1 className="text-4xl font-bold mb-4">{getCategoryLabel()}</h1>
        <p className="text-lg text-muted-foreground">
          {selectedCategory ? 
            'Dive deep into my latest thoughts and experiences.' :
            'Insights, experiences, and learnings from my journey.'
          }
        </p>
      </div>
      
      <BlogList selectedCategory={selectedCategory} />
    </div>
  );
}